import React from "react";
import { Pagination } from "antd";
import styles from "./Pagination.module.scss";

export const CustomPagination = (props: any) => {
  return <Pagination {...props} className={styles.customPagination} />;
};
